import React from 'react';
import type { ConstructionBoqItem } from '../types/construction-boq.types';
import { formatCurrency } from '@/utils/format';
import { AuthButton } from '@/core/permissions/AuthButton';

interface BoqItemTableProps {
  items: ConstructionBoqItem[];
  onEdit: (item: ConstructionBoqItem) => void;
  onDelete: (id: string) => void;
}

export function BoqItemDesktopTable({ items, onEdit, onDelete }: BoqItemTableProps) {
  return (
    <div className="overflow-x-auto -mx-6">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-slate-50/50 border-y border-slate-100">
            <th className="px-6 py-3 text-[10px] font-normal text-slate-500 tracking-widest">Mã/Hạng mục</th>
            <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest">ĐVT</th>
            <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Số lượng</th>
            <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Đơn giá</th>
            <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Thành tiền</th>
            <th className="px-6 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-center">Thao tác</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {items.map((item) => (
            <tr key={item.id} className="hover:bg-slate-50/50 transition-colors group">
              <td className="px-6 py-4">
                <div className="flex flex-col">
                  <span className="text-xs font-mono text-slate-400  tracking-tighter">{item.item_code}</span>
                  <span className="text-sm font-bold text-slate-700">{item.item_name}</span>
                  {item.description && <p className="text-[10px] text-slate-400 mt-1 line-clamp-1">{item.description}</p>}
                </div>
              </td>
              <td className="px-4 py-4 text-sm text-slate-600">{item.unit}</td>
              <td className="px-4 py-4 text-sm font-bold text-slate-700 text-right">{item.quantity}</td>
              <td className="px-4 py-4 text-sm text-slate-600 text-right">{formatCurrency(item.unit_price)}</td>
              <td className="px-4 py-4 text-sm font-bold text-os-primary text-right">{formatCurrency(item.total_amount)}</td>
              <td className="px-6 py-4">
                <div className="flex justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <AuthButton
                    module="boq"
                    action="update"
                    variant="ghost"
                    size="sm"
                    icon="ri-edit-line"
                    onClick={() => onEdit(item)}
                  />
                  <AuthButton
                    module="boq"
                    action="delete"
                    variant="ghost"
                    size="sm"
                    icon="ri-delete-bin-line"
                    className="text-red-500"
                    onClick={() => onDelete(item.id)}
                  />
                </div>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={6} className="px-6 py-12 text-center text-slate-400 italic text-sm">
                Chưa có hạng mục nào được thêm vào BOQ này.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
